import React, { useEffect, useState, useRef } from "react";
import { styled, useTheme, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";

import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import Topnavbar from "./Topnavbar";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import PostAddIcon from '@mui/icons-material/PostAdd';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import "./nav.scss";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import CollectionsIcon from '@mui/icons-material/Collections';
import { useMediaQuery } from "react-responsive";
import { Drawer as MuiDrawer } from "@mui/material/";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";

const SideNavbar = () => {
  const [open, setOpen] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [bgColor, sebgColor] = useState("black");
  const drawerWidth = 300;
  const navigate = useNavigate();
  const toggleDrawer = () => {
    setOpen(!open);
  };



  const { pathname } = useLocation();

  const MenuItems = [
  

    {
      menu: "Email Compliance",
      route: "/",
      icon: (
        <SpaceDashboardIcon className="colorCss" sx={{ fontSize: "20px" }} />
      ),
    },
    {
      menu: "Anonymizer",
      route: "/Anonymized",
      icon: (
        <PictureAsPdfIcon className="colorCss" sx={{ fontSize: "20px" }} />
      ),
    },
    {
      menu: "AP Invoice",
      route: "/email-integrations",
      icon: (
        <PostAddIcon className="colorCss" sx={{ fontSize: "20px" }} />
      ),
    },
    {
      menu: "Display Checker",
      route: "/retailDisplayChecker",
      icon: (
        <CollectionsIcon className="colorCss" sx={{ fontSize: "20px" }} />
      ),
    }
    
   
  ];

  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    background: `${bgColor}`,
    color: "white",
    overflowX: "hidden",
    borderRight: "1px dotted rgba(86,88,105, 1) !important",
    "&& .Mui-selected": {
      outline: "0px",
      border: "0px",
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      appearance: "none",
      display: "flex",
      flexGrow: "1",
      justifyContent: "flex-start",
      alignItems: "center",
      textDecoration: "none",
      boxSizing: "border-box",
      textAlign: "left",
      transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      position: "relative",
      textTransform: "capitalize",
      color: "rgb(32, 101, 209);",
      borderRadius: "8px !important",
      backgroundColor: "#0000a0",
      fontWeight: "700 !important",
    },
    "&& .logoutLayout": {
      left: "20px !important",
      position: "Absolute",
      bottom: "20px",
    },
  });

  const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: `${bgColor}`,
    color: "white",
    overflowX: "hidden",
    borderRight: "1px dotted rgba(86,88,105, 1) !important",
    padding: "0px",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(8)} + 20px)`,
    },
    "&& .Mui-selected": {
      borderRadius: "8px !important",
    },
    "&& .logoutLayout": {
      left: "8px !important",
      position: "Absolute",
      bottom: "20px",
    },
    "&& .navHistory": {
      display: "none",
    },
  });

  const openbox = (theme) => ({
    left: "286px !important",
  });

  const closebox = (theme) => ({
    left: "72px !important",
  });

  const listTogglebox = (theme) => ({
    padding: "0 !important",
    paddingTop: "2rem !important",
    padding: "1rem .5rem 0rem !important",
    borderRadius: "20px",
  });

  const listTogglebox1 = (theme) => ({
    display: "none !important",
  });

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "noWrap",
    boxSizing: "border-box",

    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
      "& .navButtonToggle": openbox(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
      "& .navButtonToggle": closebox(theme),
      "& .listToggle": listTogglebox(theme),
      "& .listToggle1": listTogglebox1(theme),
    }),
  }));




  const handleChange = () => {
    // setisDefaultPage(true);
  };


  const logout = async () => {
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    localStorage.clear();
    window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
  };

  return (
    <div>
     <div id="sidenavBarnew">
          <Box sx={{ display: "flex" }}>
            <Topnavbar
              setOpen={setOpen}
           
              open={open}
            
            />
            <Drawer
              className="sidenavBarstyle"
              variant="permanent"
              open={open}
              // sx={{
              //     display: { xs: 'none', sm: 'block' },
              //   }}
            >
              {open && (
                <>
                  <div
                    style={{
                      position: "relative",
                      marginTop: "1.2rem",
                      justifyItems: "start",
                      display: "flex",
                      paddingLeft: "1rem",
                      paddingRight: "1rem",
                      // height: "100px",
                      justifyContent: "space-between",
                      alignContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div onClick={() => setOpen(!open)}>
                      <MenuOpenIcon
                        sx={{ fontSize: "30px", cursor: "pointer" }}
                      />
                    </div>

                 
                  </div>
                </>
              )}

              {!open && (
                <>
                  <div
                    style={{
                      position: "relative",
                      marginTop: "0px",
                      height: "auto",
                    }}
                  >
                    <div
                      style={{
                        paddingTop: "1.5rem",
                        marginTop: "0px",
                        paddingBottom: "1rem",
                        display: "grid",
                        justifyContent: "center",
                        justifyItems: "center",
                      }}
                    >
                      <div onClick={() => setOpen(!open)}>
                        <MenuOpenIcon
                          sx={{
                            fontSize: "30px",
                            cursor: "pointer",
                            transform: "rotate(180deg)",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              <List
                className="listToggle"
                style={{
                  padding: "1.3rem",
                  display: "grid",
                  gridGap: "1rem",
                  paddingTop: "3rem",
                  alignContent: "baseline",
                  alignItems: "baseline",
                }}
              >
                {MenuItems.map((menuItem, index) => (
                  <Link
                    key={index}
                    style={{ color: "white" }}
                    to={`${menuItem.route}`}
                  >
                    <ListItem
                      className="itemsmenulist colorCss"
                      selected={menuItem.route === pathname}
                      disablePadding
                      sx={{ display: "block" }}
                      title={menuItem.menu}
                    >
                      <ListItemButton
                        sx={{
                          minHeight: 53,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                        onClick={() => {
                          // if (page === "Home") {
                          //   handleChange();
                          // } else {
                          //   return;
                          // }
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                          className="colorCss"
                        >
                          {menuItem.icon}
                        </ListItemIcon>
                        <ListItemText
                          className="listToggle1"
                          primary={menuItem.menu}
                          sx={{ opacity: open ? 1 : 0 }}
                        />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                ))}

              

             
              </List>
            </Drawer>

            <Dialog
              open={openDialog}
              onClose={() => setopenDialog(!openDialog)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              id="logoutPopup"
              // className="logout"
            >
              <DialogTitle id="alert-dialog-title">
                {"Are you sure you want to logout ?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Please confirm your decision.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setopenDialog(!openDialog)}>No</Button>
                <Button onClick={logout}>Yes</Button>
              </DialogActions>
            </Dialog>
          </Box>
        </div>
    </div>
  );
};

export default SideNavbar;
